import { useEffect, useState } from 'react';

export function localDay(now=new Date()) {
  const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Montevideo',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
  return ['year','month','day'].map(type=>parts.find(p=>p.type===type).value).join('-');
}
export function useDocumentDay(){
  const [day,setDay]=useState(localDay);
  useEffect(()=>{const update=()=>setDay(localDay());const timer=setInterval(update,30000);window.addEventListener('focus',update);return()=>{clearInterval(timer);window.removeEventListener('focus',update);};},[]);
  return day;
}
export function overdueDays(value,today=localDay()){
  const date=String(value||'').slice(0,10);
  if(!/^\d{4}-\d{2}-\d{2}$/.test(date))return 0;
  const timestamp=Date.parse(date+'T00:00:00Z');
  if(!Number.isFinite(timestamp)||new Date(timestamp).toISOString().slice(0,10)!==date)return 0;
  return Math.max(0,Math.floor((Date.parse(today+'T00:00:00Z')-timestamp)/86400000));
}
export const expiryFields={health_card_expires_on:'Carnet de salud',driver_license_expires_on:'Libreta de conducir'};
export function expiredDocuments(person,today=localDay()){
  return Object.entries(expiryFields).map(([key,label])=>({key,label,days:overdueDays(person[key],today)})).filter(item=>item.days>0);
}
export const expiryMessage=items=>items.map(item=>`${item.label}: vencida hace ${item.days} ${item.days===1?'día':'días'}`).join('\n');
